import { projectStages } from 'define/calculator';

export const calculatorConfigs = [
  {
    button: {
      name: 'Custom Software Development',
      value: 'custom_software_development',
    },
    config: {
      id: 'custom_software_development',
      formName: 'price-back-end-custom-soft',
      padding: 'Without',
      counter: false,
      sections: [
        {
          name: 'stage',
          type: 'stage',
          blockType: 'radioButton',
          counterType: 'radio',
          totalBoxType: 'string',
          defaultValue: false,
          title: 'What is the current stage of your software development process?',
          mobileTitles: {
            default: 'Your current project stage',
            active: 'Your current project stage',
            section: 'Your current project stage',
          },
          items: projectStages,
          fullWidth: false,
          cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
          accordion: true,
        },
        {
          name: 'professional_consultation',
          type: 'team',
          blockType: 'checkbox',
          counterType: 'checkbox',
          defaultValue: false,
          title: 'Do you need a professional consultation from any of the specialists below?',
          mobileTitles: {
            default: 'Expert consultation',
            active: 'Expert consultation',
            section: 'Expert consultation',
          },
          items: ['Project Manager', 'Business Analysts', 'UI/UX Designers', 'Architect'],
          accordion: true,
          fullWidth: false,
          cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
        },
        {
          name: 'duration',
          type: 'duration',
          blockType: 'rangeSlider',
          counterType: 'range',
          totalBoxType: 'range',
          defaultValue: false,
          initialStep: 1,
          title: 'What is the expected duration of your project?',
          mobileTitles: {
            default: 'Project duration',
            active: 'Project duration',
            section: 'Project duration',
          },
          items: [
            '1 Month',
            '2 Months',
            '3 Months',
            '4 Months',
            '5 Months',
            '6 Months',
            '7 Months',
            '8 Months',
            '9 Months',
            '10 Months',
            '11 Months',
            '12 Months',
            '13 Months',
            '14 Months',
            '15 Months',
            '16 Months',
            '17 Months',
            '18 Months',
            '19 Months',
            '20 Months',
            '21 Months',
            '22 Months',
            '23 Months',
            '24 Months',
          ],
          accordion: true,
          borderBottom: false,
          withMT: true,
        },
      ],
    },
  },
  {
    button: {
      name: 'Team augmentation',
      value: 'team_augmentation',
    },
    config: {
      id: 'team_augmentation',
      formName: 'price-back-end-team-augmentation',
      padding: 'Without',
      sections: [
        {
          name: 'development-team',
          type: 'team',
          blockType: 'counter',
          counterType: 'counter',
          defaultValue: 0,
          title: 'Your team',
          mobileTitles: {
            default: 'Your team',
            active: 'Your team',
            section: 'Your team',
          },
          items: ['Developer', 'Senior Developer', 'Tech/Team Lead', 'Architect'],
          accordion: true,
          fullWidth: false,
          cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
        },
        {
          name: 'programming_languages',
          type: 'programming_languages',
          blockType: 'checkbox',
          counterType: 'checkbox',
          defaultValue: false,
          title: 'Select your programming languages',
          mobileTitles: {
            default: 'Programming languages',
            active: 'Programming languages',
            section: 'Programming languages',
          },
          items: [
            'Java',
            '.NET',
            'PHP',
            'Python',
            'Ruby',
            'Rust',
            'Node',
            'Scala',
            'Golang',
            'C/C++',
          ],
          accordion: true,
          fullWidth: false,
          cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
        },
        {
          name: 'stage',
          type: 'stage',
          blockType: 'radioButton',
          counterType: 'radio',
          totalBoxType: 'string',
          defaultValue: false,
          title: 'What is the current stage of your software development process?',
          mobileTitles: {
            default: 'Your current project stage',
            active: 'Your current project stage',
            section: 'Your current project stage',
          },
          items: projectStages,
          accordion: true,
          withMT: true,
          borderBottom: false,
        },
        {
          name: 'additional-development-team',
          type: 'team',
          blockType: 'counter',
          counterType: 'counter',
          defaultValue: 0,
          title: 'Extra specialists you need to add to the team',
          mobileTitles: {
            default: 'Extra specialists to add',
            active: 'Extra specialists to add',
            section: 'Extra specialists to add',
          },
          items: [
            'Project Manager',
            'UI/UX Designer',
            'Business Analyst',
            'DevOps Engineer',
            'QA/QA Automation Engineer',
            'Support Specialist',
            'IT Security Specialist',
            'Front-end Engineer',
          ],
          accordion: true,
          borderBottom: false,
        },
        {
          name: 'duration',
          type: 'duration',
          blockType: 'rangeSlider',
          counterType: 'range',
          totalBoxType: 'range',
          defaultValue: false,
          initialStep: 1,
          title: 'What is the expected duration of your project?',
          mobileTitles: {
            default: 'Project duration',
            active: 'Project duration',
            section: 'Project duration',
          },
          items: [
            '1 Month',
            '2 Months',
            '3 Months',
            '4 Months',
            '5 Months',
            '6 Months',
            '7 Months',
            '8 Months',
            '9 Months',
            '10 Months',
            '11 Months',
            '12 Months',
            '13 Months',
            '14 Months',
            '15 Months',
            '16 Months',
            '17 Months',
            '18 Months',
            '19 Months',
            '20 Months',
            '21 Months',
            '22 Months',
            '23 Months',
            '24 Months',
          ],
          accordion: true,
          borderBottom: false,
        },
      ],
    },
  },
];
